import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { useLenis } from "@/components/SmoothScroll";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    const target = hash ? document.getElementById(hash.slice(1)) : null;
    const t = setTimeout(() => {
      if (target) {
        if (lenis) lenis.scrollTo(target, { offset: -90 });
        else target.scrollIntoView();
      } else if (lenis) lenis.scrollTo(0, { immediate: true });
      else window.scrollTo(0, 0);
    }, target ? 120 : 0);
    return () => clearTimeout(t);
  }, [pathname, hash, lenis]);
  return null;
};

export const Layout = () => (
  <>
    <ScrollManager />
    <Header />
    <main id="main" className="pt-20">
      <Outlet />
    </main>
    <Footer />
  </>
);
